import React, { memo, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Placement } from 'react-bootstrap/types'
import { DescriptionBtnWithPopup } from '../buttons/PromptBtn/DescriptionBtnWithPopup'
import { RiskyParamUnlockBtn } from './components/RiskyParam/RiskyParamUnlockBtn'

export interface ISelectItems {
    options: string[]
    label?: string | null
    name: string
    state: any
    touched?: any
    errors?: any
    errorText?: string
    className?: string
    translateItems?: boolean
    isDisabled?: boolean
    tooltipPosition?: Placement
    style?: any
    flag?: boolean
    tooltipText?: string
    selected?: number
    isColumn?: boolean
    isLabelHidden?: boolean
    disabledOptions?: string[]
    changeWarning?: string
    convert?(option: any): string
    setState(state: any): any
    setTouched?(touched: any): any
    onChange?: Function
}

export const SelectInput = memo(function SelectInput({
    className,
    label,
    name,
    options,
    state,
    setState,
    isDisabled,
    style,
    flag,
    tooltipText,
    selected,
    setTouched,
    touched,
    isColumn,
    isLabelHidden,
    tooltipPosition,
    disabledOptions = [],
    changeWarning,
    onChange,
}: ISelectItems) {
    const [isRiskyParam, setIsRiskyParam] = useState(!!changeWarning)
    const handleUnlockRiskyParam = () => setIsRiskyParam(false)

    useEffect(() => {
        if (selected) {
            // without timeout set value is being manipulated
            setTimeout(() => {
                setState((prev: typeof state) => {
                    return { ...prev, [name]: selected }
                })
            }, 0)
        }
    }, []) // eslint-disable-line

    const optionComponents = React.useMemo(
        () =>
            options.map((option: string) => {
                if (disabledOptions.includes(option)) {
                    return (
                        <option
                            key={option}
                            value={option}
                            className={flag ? 'first-hiden' : ''}
                            disabled
                        >
                            {option.replaceAll('_', ' ')}
                        </option>
                    )
                }
                return (
                    <option
                        key={option}
                        value={option}
                        className={flag ? 'first-hiden' : ''}
                    >
                        {option.replaceAll('_', ' ')}
                    </option>
                )
            }),
        [options] // eslint-disable-line
    )

    const handleChange = (event: any): void => {
        setTouched && setTouched({ ...touched, [name]: true })
        setState({ ...state, [name]: event.target.value })
        if (typeof onChange === 'function') onChange(event.target.value)
    }

    const handleBlur = (): void => {
        setTouched && setTouched({ ...touched, [name]: true })
    }

    return (
        <Form.Group
            style={{ maxWidth: '600px' }}
            className={`${className} mt-1 mb-1 d-flex flex-1 justify-content-between align-items-baseline`}
        >
            {label ? (
                <Form.Label
                    style={{
                        maxWidth: isColumn ? '30%' : 'auto',
                        opacity: isRiskyParam ? '50%' : '100%',
                    }}
                    className="label-main mt-1 text-capital pe-2"
                >
                    {label}:
                </Form.Label>
            ) : null}
            <div
                style={{ width: isLabelHidden ? '100%' : '70%' }}
                className={`d-flex ${!isColumn ? 'flex-1' : ''}`}
            >
                <span className="d-flex align-items-start w-100 p-relative">
                    {isRiskyParam && <div className="input-overlay" />}
                    <Form.Select
                        onBlur={handleBlur}
                        as={tooltipText ? 'text' : 'select'}
                        name={name}
                        value={state?.[name] ?? ''}
                        onChange={handleChange}
                        disabled={!!isDisabled}
                        style={style}
                        tabIndex={isRiskyParam ? -1 : 0}
                    >
                        {optionComponents}
                    </Form.Select>
                    {tooltipText && (
                        <DescriptionBtnWithPopup
                            type={'default'}
                            header={label ?? ''}
                            description={tooltipText ?? ''}
                            className="mt-1 input-tooltip"
                            placement={tooltipPosition}
                        />
                    )}
                </span>
                {isRiskyParam && (
                    <RiskyParamUnlockBtn
                        onUnlockConfirm={handleUnlockRiskyParam}
                        changeWarning={changeWarning}
                    />
                )}
            </div>
        </Form.Group>
    )
})